export default __webpack_public_path__ + "static/media/Q22018.144ee47b.PDF";